<template>
  <v-card>
    <v-card-title v-if="title">
      <slot name="title">
        <span
          :class="titleClass"
          v-text="title" />
      </slot>
    </v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <DialogActions
        :actions="actions"
        ref="actions"
        outline
        color="blue-grey"
        :handle="handle" />
    </v-card-actions>
  </v-card>
</template>

<script>

import DialogActions from './DialogActions.vue'

export default {
  components: {
    DialogActions
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: 'headline'
    },
    actions: {
      type: [Array, Object],
      default: null
    },
    handle: {
      type: Function,
      default: null
    }
  },
  methods: {
    trigger (name) {
      this.$refs.actions && this.$refs.actions.trigger(name)
    }
  }
}
</script>
<style>
  .vuedl-layout.v-dialog--scrollable > .v-card > .v-card__text {
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
  }
</style>
